import React, { ComponentProps } from 'react'

import ChakraUIRenderer from 'chakra-ui-markdown-renderer'
import ReactMarkdown from 'react-markdown'
import { Heading, Text } from '@chakra-ui/react'

export const MarkdownRenderer = ({
  text,
  ...props
}: { text?: string | null } & Omit<
  ComponentProps<typeof ReactMarkdown>,
  'children'
>) => {
  return (
    <ReactMarkdown components={ChakraUIRenderer(customTheme)} {...props}>
      {text || ''}
    </ReactMarkdown>
  )
}

const customTheme = {
  p: ({ children }: { children: React.ReactNode }) => {
    return (
      <Text mt="3" mb="1">
        {children}
      </Text>
    )
  },
  h3: ({ children }: { children: React.ReactNode }) => {
    return (
      <Heading mt="3" mb="1" size="md" as="h3">
        {children}
      </Heading>
    )
  },
}
